export default __webpack_public_path__ + "static/timeline-be7e42d5fe3f756b32682e19a646dc7a.png";